import { useState, useEffect, useCallback } from "react";
import { T } from "./i18n";

const KEY = "swap_lang";

export function useLanguage() {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(KEY);
    if (saved) return saved;
    return navigator.language?.startsWith("en") ? "en" : "fr";
  });

  const setLang = useCallback((l) => {
    localStorage.setItem(KEY, l);
    setLangState(l);
    window.dispatchEvent(new CustomEvent("swaplang", { detail: l }));
  }, []);

  useEffect(() => {
    const h = (e) => setLangState(e.detail);
    window.addEventListener("swaplang", h);
    return () => window.removeEventListener("swaplang", h);
  }, []);

  return { lang, setLang };
}

export function useT() {
  const { lang } = useLanguage();
  return useCallback((key) => T[lang]?.[key] || T.fr?.[key] || key, [lang]);
}